import React, { useMemo } from 'react';
import { BeefCoExtContext, BeefCoProjectContext } from '@beefco/sdk-shared';
import { useMemoizedExt, useProjectConfigMemo } from "./memoized";
import { defaultExtractPageDSL } from "./defaults";

/**
 * Config provider contains all the customizable properties of a BeefCo projects, such as indents, widths, fonts etc.
 * What if provider is added but no beef yet?
 */
export var withBeefCoProject = function withBeefCoProject() {
  var project = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extractPageDSL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultExtractPageDSL;
  return function (WrappedComponent) {
    return function (props) {
      var _useMemo = useMemo(function () {
          return extractPageDSL(props);
        }, [props]),
        beefCo = _useMemo.beefCo,
        model = _useMemo.model;
      return /*#__PURE__*/React.createElement(BeefCoProjectContext.Provider, {
        value: useProjectConfigMemo(project, beefCo)
      }, /*#__PURE__*/React.createElement(BeefCoExtContext.Provider, {
        value: useMemoizedExt()
      }, /*#__PURE__*/React.createElement(WrappedComponent, model)));
    };
  };
};